// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__LPGTs","content":"styles_content__1cwtt"};